module.exports = {
  menu: {
    srcQiYe: require("@/assets/images/FanTiPageTop/img_jianjie.jpg"),
    // 橡胶
    rubber_img: require("@/assets/images/FanTiPageTop/jiance_tw.jpg"),
    // 公司动态
    CompanyDnamicImg: require("@/assets/images/FanTiPageTop/img_dontai.jpg"),
    // 行业质询
    InformationImg: require("@/assets/images/FanTiPageTop/img_zixun.jpg"),
    // 实验室中心
    LaboratoryCenterImg: require("@/assets/images/FanTiPageTop/img_shiyanshi.jpg"),
    // 人才招聘
    RecruitmentImg: require("@/assets/images/FanTiPageTop/img_zhaopin.jpg"),
    // 预约检查
    MakeAppointmentImg: require("@/assets/images/FanTiPageTop/img_yuyue.jpg"),
    //申请表
    TestApplicationFormImg: require("@/assets/images/FanTiPageTop/img_shenqingbiao.jpg"),
    // 报告查询
    TheReportQueryImg: require("@/assets/images/FanTiPageTop/img_chaxun.jpg"),

    // 送检流程
    TheInspectionProcessImg: require("@/assets/images/FanTiPageTop/img_liucheng.jpg"),
    // 调查和报价
    SurveyandQuotationImg: require("@/assets/images/FanTiPageTop/img_diaocha.jpg"),
    // 意见或建议
    OpinionOrAdviceImg: require("@/assets/images/FanTiPageTop/img_yijian.jpg"),
    CustomerInspectionImg: require("@/assets/images/FanTiPageTop/img_xuzhi.jpg"),

    messageOne: "請輸入用戶名",
    messageTwo: "請輸入聯係電話",
    messageSan: "請輸入郵箱",
    messageGongSi: "請輸入公司名稱",
    messageYiJian: "請輸入意見或建議",

    placeholder: "請選擇",
    nodatatext: "無數據",
    messageHeFaEamil: "請輸入合法郵箱",
    messageHeFaPhone: "請輸入合法電話",

    tijiaoChengGong: "發送成功",
    tijiaoError: "發送失敗",

    liuyan: "給我們留言",
    dianziemit: "電子郵箱",
    jobwork: "職位",
    country: "國/省/市",
    messageContents: "留言內容",
    shurucocntent: "請在此輸入留言內容，我們會儘快與您聯系",
    provide:
      "您所提供得個人資料將只會作為公司內部使用，而未來相關的市場資訊將會通過電郵及時通知您。",

    KEYWords:
      "“橡膠材料檢測，塑膠材料檢測，橡塑材料檢測，材料物理性能檢測，司達行（廣州）實驗室有限公司，廣州實驗室公司，第三方檢測機構、第三方檢測實驗室。”",
    DEscription:
      "是一家具有獨立法人的第三方檢測實驗室，依据《檢驗檢測機構資質認定能力評價檢驗檢測機構通用要求(RB/T214-2017)》和《檢測和校準實驗室能力認可準則 (ISO/IEC 17025:2017)》建立并保持實驗室管理體系，目前正在籌備CMA與CNAS認證認可工作。獲批準后，將能夠為客戶提供認可的檢測報告。" +
      "業務範圍：針對橡塑材料製品、日用品提供物理可靠性能項目的檢測和服務，例如：高低溫老化試驗、硬度、拉伸、耐臭氧、耐磨試驗等。",

    BTitle: "廣州司達行航空密封製造有限公司檢測中心",
    languageName: "繁體",
    qiye: "實驗室簡介",

    AboutUs: "關於我們",
    business: "檢測範圍",
    Rubber: "橡膠材料檢測",

    OXinQuan: "O形圈檢測",
    DianziDianGong: "電工電子產品檢測",
    ZhiXun: "致電參觀：",

    PlasticMaterials: "塑料材料檢測",
    New: "新聞資訊",
    CompanyDnamic: "公司動態",
    IndustryInformation: "行業資訊",
    Team: "團隊",

    LaboratoryCenter: "實驗室中心", //2
    Recruitment: "人才招聘",
    customer: "客戶服務",
    theDay: "預約檢測",
    Testapplicationform: "檢測申請表",
    TheReportQuery: "報告查詢",
    TheInspectionProcess: "送檢流程",
    contactUs: "聯繫我們",
    SurveyAndQuotation: "聯繫方式",
    suggestion: "意見或建議",
    Instructions: "客戶檢測須知",

    viewMore: "查看更多",
    particulars: "詳情",

    CustomerInstructions: "客戶檢測須知",
    regulations: "客戶在申請檢測之前，請先了解相關條款及細則",
    introduce: "實驗室介紹",
    ServicesAvailable: "檢測項目",
    USCDCLab: "實驗室照片",
    laboratoryEquipment: "實驗室設備",
    portal: "傳送門",

    // DetectionOfConsulting:"检测咨询",
    ApplicationForm: "檢測申請表下載",
    // TheInspectionProcess:"送检流程",
    CommentsOrSuggestions: "意見或建議反饋",

    // footer
    SweepYardsAttention: "掃碼關注",
    WeChatOfficialAccount: "微信公眾號",
    tel: "電話：",
    fax: " 傳真：",
    mailbox: "郵箱：",
    companyAddress: " 地址：",
    businessHours: "營業時間：",
    detectionRange: " 檢測範圍：",

    CallUs: "致電我們",
    // 硬度试验
    briefIntroduction: "基本介紹",
    consult: "諮詢",
    feedback: "反饋",
    testContent: "項目名稱與檢測內容",
    precautions: "檢測週期與注意事項",
    ServiceContent: "服務內容",
    testItem: "檢測項目",
    advantages: "我們的優勢",
    recommendation: "相關推薦",
    testItemer: "型號規格：",

    releaseDate: "發佈時間：",
    source: "來源：",
    publisher: "發佈者：",
    previousposts: "上一篇：",
    nextChapter: "下一篇：",

    // 实验室
    // ServicesAvailable :"服务项目",
    LaboratoryPhotograph: "實驗室照片",
    laboratoryEquipment: "實驗室設備",
    deliver: "投遞",

    WorkingArea: "上班地區：",
    recruitingNumbers: "招聘人數：",
    ExperienceRequirements: "經驗要求：",
    educationalRequirements: "學歷要求：",
    responsibilities: "工作職責:",
    jobRequirements: "任職要求:",
    RongYu: "榮譽資質",

    jobtitle: "職位名稱",
    reDate: "發佈時間",
    // 投递信息
    deliveryOfInformation: "投遞信息",
    name: "姓名",
    phone: "聯繫電話",
    // mailboxer:"電子郵箱",
    entryDate: "可到職日期",
    // entryDateer   : "选择日期",
    introduce: "自我介紹",
    offer:
      "您所提供得個人資料將只會作為公司內部使用，而未來相關的市場資訊將會通過電郵及時通知您",
    SlectFile: "選擇文件",

    send: "發送",
    reset: "重置",
    Select: "查詢",

    // 申请表
    EntrustedTesting: "委託檢測申請表",
    download: "下載",

    // 报告编号
    reportNumber: "報告編號",
    InquiryTip:
      " 査詢提示：報告查驗可通過手機“掃一掃”報價單上生成的二維碼來査詢報告相關資訊",
    ReportFiles: " (此處只支持查詢結果)如索取報告請致電業務員。",
    salesman: "業務員：",

    JianCeBiaoZhun: "檢測標準：",

    searchResult: "查詢結果",
    inputError: "輸入有誤，不存在相關的報告或資料（請與實驗室相關人員聯系）",
    applicationDate: "簽發日期：",
    sampleName: "樣品名稱：",
    // testItem:"檢測項目",
    testingResult: "檢測結果：",
    TestCompletionDate: "備注：",
    confirm: "確定",

    companyName: "公司名稱",
    // details:"意見或建議",
    // interior:"您所提供得个人资料将只会作为公司内部使用，而未来相关得市场资讯将会通过电邮及时通知您",
    pleaseAdvise: "請告知我們您的意見及建議，我們將認真研究您的建議，努力為您提供更優質更便捷的服務。",
    landlineMachine: "020-34773221轉840",
  },
  content: {
    main: "",
  },
};
